module.exports = {"650171001":"中亚北路街道","650171002":"中亚南路街道","650171004":"嵩山街街道","650171005":"高铁片区管委会","650171006":"白鸟湖片区管委会","650171007":"西湖片区管委会","650171008":"北站东路街道","650171009":"两河片区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650171.json
// module id = 3056
// module chunks = 0